module.exports = __webpack_public_path__ + "img/calendar-day.3f5be98c.svg";